import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/Login';
import Members from '@/components/pages/Members/Members';
import Member from '@/components/pages/Members/Member';
import Branches from '@/components/pages/Branches/Branches';
import Branch from '@/components/pages/Branches/Branch';
import Payments from '@/components/pages/Payments/Payments';
import Payment from '@/components/pages/Payments/Payment';
import Subscriptions from '@/components/pages/Subscriptions/Subscriptions';
import Subscription from '@/components/pages/Subscriptions/Subscription';
import Reports from '@/components/pages/Reports/Reports';
import Report from '@/components/pages/Reports/Report';
import Codebooks from '@/components/pages/Codebooks/Codebooks';
import UserAccounts from '@/components/pages/UserAccounts/UserAccounts';
import UserAccount from '@/components/pages/UserAccounts/UserAccount';
import Import from '@/components/pages/Import/Import';

Vue.use(Router);

export default new Router({
	routes: [
		{ path: '/login', name: 'login', component: Login, meta: {} },
		{ path: '/members', name: 'members', component: Members, meta: {} },
		{ path: '/members/:id', name: 'member', component: Member, meta: {} },
		{ path: '/branches', name: 'branches', component: Branches, meta: {} },
		{ path: '/branches/:id', name: 'branch', component: Branch, meta: {} },
		{ path: '/payments', name: 'payments', component: Payments, meta: {} },
		{ path: '/payments/:id', name: 'payment', component: Payment, meta: {} },
		{ path: '/subscriptions', name: 'subscriptions', component: Subscriptions, meta: {} },
		{ path: '/subscriptions/:id', name: 'subscriptions', component: Subscription, meta: {} },
		{ path: '/reports', name: 'reports', component: Reports, meta: {} },
		{ path: '/reports/:id', name: 'report', component: Report, meta: {} },
		{ path: '/codebooks', name: 'codebooks', component: Codebooks, meta: {} },
		{ path: '/user-accounts', name: 'userAccounts', component: UserAccounts, meta: {} },
		{ path: '/user-accounts/:id', name: 'userAccount', component: UserAccount, meta: {} },
		{ path: '/import', name: 'import', component: Import, meta: {} },
	],
});
